import { css } from 'lit';

export default css`
  :host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --background-color: var(--webmodule-tooltip-background-color);
    --color: var(--webmodule-tooltip-color);

    --arrow-size: var(--webmodule-tooltip-arrow-size);
    --arrow-color: var(--background-color);
  }

  .tooltip::part(popup) {
    z-index: var(--webmodule-z-tooltip);
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--webmodule-tooltip-border-radius);
    background-color: var(--background-color);
    font-family: var(--webmodule-tooltip-font-family);
    font-size: var(--webmodule-tooltip-font-size);
    font-weight: var(--webmodule-tooltip-font-weight);
    line-height: var(--webmodule-tooltip-line-height);
    text-align: start;
    white-space: normal;
    color: var(--color);
    padding: var(--webmodule-tooltip-padding);
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    box-shadow: var(--webmodule-shadow-large);
  }
`;
